export enum TRACKING_VERSIONS {
	RP3 = "RP3.0",
	RP2 = "RP2.0"
}
